import React, { Component } from 'react'
import styles from './style.module.less'
import { PROPERTY_WEDDING_PHOTO_ID, STORE_PUBLISH_MEAL_PATH_A } from '@constant'
import { getSessionMerchantInfo } from '@merchant-backend/util'
export default class extends Component {
  linkTo = type => () => {
    window.location.href = `${STORE_PUBLISH_MEAL_PATH_A}?weddingPhotoType=${type}&propertyId=${PROPERTY_WEDDING_PHOTO_ID}`
  }

  render() {
    let merchant_info = getSessionMerchantInfo()
    let is_dalian = merchant_info.city_code == 29 //DEV-10639 大连的婚纱摄影商家修改为可创建婚纱摄影套餐
    let is_lvpai =
      merchant_info.is_lvpai && merchant_info.is_lvpai == 1 && !is_dalian

    return (
      <div className={styles.contentWrap}>
        <p>选择婚纱摄影套餐类型</p>
        <ul className={styles.imageWrap2}>
          {!is_lvpai && (
            <li onClick={this.linkTo('1')}>
              <img src="http://qnm.hunliji.com/o_1c7918rc71s3a3fg1u991g8469u8.png" />
              <p>婚纱摄影</p>
            </li>
          )}

          <li onClick={this.linkTo('4')}>
            <img src="http://qnm.hunliji.com/o_1c791cecopd8168lclklu01uq6n.png" />
            {is_lvpai ? <p>婚纱摄影/旅拍</p> : <p>旅拍</p>}
          </li>
          <li onClick={this.linkTo('2')}>
            <img src="http://qnm.hunliji.com/o_1c791aa664nv8r3152u19mt1acgd.png" />
            <p>儿童摄影</p>
          </li>
          {is_lvpai && (
            <li onClick={this.linkTo('3')}>
              <img src="http://qnm.hunliji.com/o_1c791bnn627lam31u921jlm8vi.png" />
              <p>写真摄影</p>
            </li>
          )}
        </ul>

        <ul className={styles.imageWrap2}>
          {!is_lvpai && (
            <li onClick={this.linkTo('3')}>
              <img src="http://qnm.hunliji.com/o_1c791bnn627lam31u921jlm8vi.png" />
              <p>写真摄影</p>
            </li>
          )}
          <li onClick={this.linkTo('5')}>
            <img src="http://qnm.hunliji.com/o_1c791equj1ml8p9aqoejem15os.png" />
            <p>结婚登记照</p>
          </li>
        </ul>
      </div>
    )
  }
}
